const FooterText = () => {
  return (
    <footer className="text-center relative text-white mx-auto w-[50vw] mt-32">
      <p className="font-bold mb-5">TEXTO LEGAL</p> 
      <span className="text-lg">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam nec
        tellus eu nisi eleifend auctor. Nulla quis odio in justo vestibulum
        varius eu in quam. Fusce auctor quam quis tincidunt scelerisque. Sed id
        risus et orci efficitur gravida. Nullam luctus libero in eros dictum,
        sit amet pulvinar odio suscipit. <br /> <br /> Maecenas fermentum ante sit amet urna
        rhoncus tincidunt. Vestibulum quis gravida libero. Suspendisse iaculis
        dictum malesuada. Duis non leo id turpis facilisis vehicula. Vestibulum
        et lacinia justo. Praesent fermentum, turpis sit amet vehicula suscipit,
        neque est bibendum eros, vitae interdum elit nulla eu enim. Aenean
        euismod ex eu nibh interdum, sit amet pulvinar ipsum facilisis. Mauris
        malesuada congue lectus, ac finibus nisi. Etiam ullamcorper nisi in odio
        varius scelerisque. 
      </span>
    </footer>
  )
}

export default FooterText
